var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"MCM_SVG_Icons"),React.createElement("path",{"id":"Email","fill":"#231F20","d":"M1.9,3.42c-0.27,0-0.53,0.07-0.76,0.19l10.39,11.16c0.22,0.24,0.73,0.24,0.95,0l10.4-11.16\n\tc-0.23-0.12-0.5-0.19-0.76-0.19H1.9z M0.29,4.56C0.17,4.82,0.11,5.11,0.11,5.4v13.87c0,1.1,0.79,1.98,1.78,1.98H22.1\n\tc0.99,0,1.78-0.88,1.78-1.98V5.4c0-0.29-0.06-0.58-0.17-0.85L13.31,15.73c-0.72,0.78-1.89,0.78-2.62,0L0.29,4.56z","key":1})]);
}

Email.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"24px","height":"24px","viewBox":"0 0 24 24","enableBackground":"new 0 0 24 24","xmlSpace":"preserve"};

module.exports = Email;

Email.default = Email;
